module.exports = __webpack_public_path__ + "static/media/Right legs08.bf17b228.png";